/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientProcedurePlan from './patient-procedure-plan';
import PatientProcedurePlanDetail from './patient-procedure-plan-detail';
import PatientProcedurePlanUpdate from './patient-procedure-plan-update';
import PatientProcedurePlanDeleteDialog from './patient-procedure-plan-delete-dialog';

const PatientProcedurePlanRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientProcedurePlan />} />
    <Route path="new" element={<PatientProcedurePlanUpdate />} />
    <Route path=":id">
      <Route index element={<PatientProcedurePlanDetail />} />
      <Route path="edit" element={<PatientProcedurePlanUpdate />} />
      <Route path="delete" element={<PatientProcedurePlanDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientProcedurePlanRoutes;
